<template>
  <div class="todaycourse-page">
    <van-tabs v-model="active" @click="onClick">
      <van-tab
        v-for="(item, index) in titleArray"
        :title="item"
        :key="'tabpage' + index"
        title-class="todaycourse-tabtitle"
      >
        <teas-today-course-main
          :ref="'todaycoursemain' + index"
          :classType="typeArray[index]"
          @itemClick="itemClick"
          :is-design="isDesign"
          :url="url"
        ></teas-today-course-main>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import teasTodayCourseMain from "./teasTodayCourseMain.vue";
export default dsf.component({
  name: "DsfMobileTeasTodayCourse",
  ctrlCaption: "今日课程",
  mixins: [$mixins.control],
  design: {
    isMask: false,
  },
  components: {
    teasTodayCourseMain,
  },
  props: {
    url: {
      type: String,
      default: "teas/schedule/course/arrange/getClassStructureCourseByTime",
    },
  },
  data() {
    return {
      active: 0,
      currentDate: "",
      titleArray: ["全部", "主体班", "外培班"],
      typeArray: ["1,2,3,4", "2,3", "4"],
    };
  },
  created() {},
  activated() {
    this.loadCurrentData();
  },
  methods: {
    loadCurrentData() {
      let tempListName = "todaycoursemain" + this.active;
      this.$refs[tempListName][0].reloadDateData();
    },
    itemClick(args) {
      if (this.$listeners["itemClick"]) {
        this.$dispatch("itemClick", args);
      }
    },
    getCurrentPageType(){
      return this.typeArray[this.active];
    }
  },
});
</script>
